<script>
import bem from '@/utils/bem';
import VariablePopup from '@/pages/settings/emailsTab/Variable-popup.vue';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';
import { ColorPicker } from 'vue3-colorpicker';
import {
  GEN_LINKS,
  DESCRIPTION_ENTER_VARIABLE,
  DESCRIPTION_ENTER_LINK,
  DESCRIPTION_ENTER_CUSTOM_LINK,
} from '@/pages/settings/emailsTab/constants';

const b = bem('content-editor');

export default {
  components: {
    VariablePopup,
    ModalWrapper,
    ColorPicker,
  },
  data() {
    const linkList = this.isGenerateLink ? [...GEN_LINKS, ...this.links] : this.links;
    return {
      styleData: this.data,
      styleColumnData: this.columnData,
      textValue: this.startTextValue,
      hrefValue: linkList.find(({ value }) => value === this.startHref) || this.startHref,
      hrefCustomValue: this.startHref && linkList.find(({ value }) => value === this.startHref)
        ? ''
        : this.startHref,
      isCustomHref: this.startHref && !linkList.find(({ value }) => value === this.startHref),
      linkList,
      textPopup: null,
      textCursorPos: null,
      visible: true,
      DESCRIPTION_ENTER_VARIABLE,
      DESCRIPTION_ENTER_LINK,
      DESCRIPTION_ENTER_CUSTOM_LINK,
    };
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columnData: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    withText: {
      type: Boolean,
      required: false,
      default: false,
    },
    startTextValue: {
      type: String,
      required: false,
      default: '',
    },
    withHref: {
      type: Boolean,
      required: false,
      default: false,
    },
    startHref: {
      type: String,
      required: false,
      default: '',
    },
    withLinks: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGenerateLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    links: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    constants: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    save: {
      type: Function,
      required: false,
      default: () => {},
    },
    close: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onChange(value, name) {
      this.styleData = this.styleData.map((item) => {
        if (item.name === name && item.name === 'border') {
          return { ...item, value: `${item.value.slice(0, -7)}${value}` };
        }
        return item.name === name ? { ...item, value } : item;
      });
    },
    onChangeColumn(value, name) {
      this.styleColumnData = this.styleColumnData.map((item) => {
        if (item.name === name && item.name === 'border') {
          return { ...item, value: `${item.value.slice(0, -7)}${value}` };
        }
        return item.name === name ? { ...item, value } : item;
      });
    },
    saveStyle() {
      const newStyle = this.styleData.reduce((acc, item) => {
        const {
          name, value, postfix, isCheckbox,
        } = item;
        return {
          ...acc,
          [name]: name === 'font-weight'
            ? value
            : `${isCheckbox ? '' : value}${value ? postfix : ''}`,
        };
      }, {});

      const newColumnStyle = this.styleColumnData.reduce((acc, item) => {
        const {
          name, value, postfix, isCheckbox,
        } = item;
        return {
          ...acc,
          [name]: name === 'font-weight'
            ? value
            : `${isCheckbox ? '' : value}${value ? postfix : ''}`,
        };
      }, {});

      this.save({
        newStyle,
        newColumnStyle,
        ...(this.withText ? { newText: this.textValue } : {}),
        ...(this.withHref
          ? {
            newHref: this.isCustomHref
              ? this.hrefCustomValue
              : (this.hrefValue || {}).value,
          } : {}
        ),
      });
    },
    onChangeText(e) {
      const {
        target: {
          value,
          selectionStart,
        },
      } = e;
      this.textValue = value;

      if (selectionStart >= 2) {
        const twoCharsBefore = value.substr(selectionStart - 2, 2);
        if (twoCharsBefore === '[[' && this.withLinks) {
          this.textCursorPos = selectionStart;
          e.target.blur();
          this.textPopup = 'link';
        } else if (twoCharsBefore === '{{') {
          this.textCursorPos = selectionStart;
          e.target.blur();
          this.textPopup = 'variable';
        } else if (twoCharsBefore === '<<' && this.withLinks) {
          this.textCursorPos = selectionStart;
          e.target.blur();
          this.textPopup = 'customLink';
        }
      }
    },
    saveVariable(popupTextValue, popupSelectorValue) {
      const pos = this.textCursorPos;
      const before = pos !== null ? this.textValue.substring(0, pos) : this.textValue;
      const after = pos !== null ? this.textValue.substring(pos) : '';

      if (this.textPopup === 'link') {
        this.textValue = `${before}${popupTextValue}|${popupSelectorValue}]]${after}`;
      }

      if (this.textPopup === 'customLink') {
        this.textValue = `${before}${popupTextValue}|${popupSelectorValue}>>${after}`;
      }

      if (this.textPopup === 'variable') {
        this.textValue = `${before}${popupSelectorValue}}}${after}`;
      }

      this.textPopup = null;
      this.textCursorPos = null;
    },
    closeVariable() {
      this.textPopup = null;
      const pos = this.textCursorPos;
      if (pos !== null) {
        const before = this.textValue.substring(0, pos - 2);
        const after = this.textValue.substring(pos);
        this.textValue = `${before}${after}`;
        this.textCursorPos = null;
      } else {
        this.textValue = this.textValue.slice(0, -2);
      }
    },
    getOptions(list) {
      return list.map((itm) => ({ label: itm, text: itm, value: itm }));
    },
  },
  watch: {
    visible(newValue) {
      if (!newValue) {
        this.close();
      }
    },

  },
};

</script>

<template>
  <modal-wrapper v-model:show="visible">
    <div :class="b()">
      <template v-if="textPopup">
        <variable-popup
          :closeVariable="closeVariable"
          :saveVariable="saveVariable"
          :textPopup="textPopup"
          :className="b('variable-popup')"
          :links="links"
          :constants="constants"
        />
      </template>
      <div
        v-if="withText"
        :class="b('style-item', { 'text-area': true })"
      >
        <div :class="b('title')">Text</div>
        <a-textarea
          :value="textValue"
          :auto-size="{ minRows: 4, maxRows: 10 }"
          @input="(e) => {onChangeText(e)}"
          placeholder="Enter text..."
        />
      </div>
      <div :class="b('hints-container')">
          <div :class="b('hint-item')">
            <span :class="b('hint-trigger')">{{'{'+'{'}}</span>
            <!-- eslint-disable-next-line max-len -->
            <span :class="b('hint-text')">Add variable (delete from {{'{'+'{' }} to {{'}'+'}'}})</span>
          </div>
          <div :class="b('hint-item')" v-if="withLinks">
            <span :class="b('hint-trigger')">[[ </span>
            <span :class="b('hint-text')">Add link (delete from [[ to ]])</span>
          </div>
          <div :class="b('hint-item')" v-if="withLinks">
            <span :class="b('hint-trigger')">&lt;&lt;</span>
            <span :class="b('hint-text')">Add custom link (delete from &lt;&lt; to &gt;&gt;)</span>
          </div>
      </div>
      <div
        v-if="withHref"
        :class="b('style-item')"
      >
        <div :class="b('title')">Link</div>
        <a-input
          v-if="isCustomHref"
          v-model:value="hrefCustomValue"
          style="width: 180px"
        />
        <a-select
          v-else
          style="width: 180px"
          :value="hrefValue"
          :options="linkList"
          @change="((e) => { this.hrefValue = linkList.find((itm) => itm.value === e) })"
        />
        <a-switch
          style="min-width: 85px"
          checked-children="Custom"
          un-checked-children="Hardcode"
          v-model:checked="isCustomHref"
        />
      </div>
      <div
        :class="b('style-item')"
        v-for="({
          name,
          title,
          value,
          options,
          isCheckbox,
          isColor,
        }) in styleData"
        :key="`stile-section-${name}`"
      >
        <div :className="b('title')">{{title}}</div>
        <a-input
          v-if="!options && !isCheckbox && !isColor"
          type="text"
          :value="value"
          @change="(e) => { onChange(e.target.value, name); }"
        />
        <div
          :class="b('color-picker-wrapper')"
          v-if="isColor"
        >
          <color-picker
            :pureColor="name === 'border' ? value.slice(-7) : value"
            :format="'hex6'"
            :isWidget="true"
            :disableAlpha="true"
            @pureColorChange="(hex) => { onChange(hex, name); }"
          />
        </div>
        <a-select
          v-if="options && options.length"
          style="width: 180px"
          :value="{ label: value, text: value, value }"
          :options="getOptions(options)"
          @change="((e) => {
            onChange(e, name)
          })"
        />
        <a-switch
          v-if="isCheckbox"
          :checked="value"
          checked-children="Yes"
          un-checked-children="No"
          @click="() => { onChange(!value, name); }"
        />
      </div>
      <div
        :class="b('style-item')"
        v-for="({
          name,
          title,
          value,
          options,
          isCheckbox,
          isColor,
        }) in styleColumnData"
        :key="`stile-column-${name}`"
      >
        <div :className="b('title')">{{title}}</div>
        <a-input
          v-if="!options && !isCheckbox && !isColor"
          type="text"
          :value="value"
          @change="(e) => { onChangeColumn(e.target.value, name); }"
        />
        <color-picker
          v-if="isColor"
          :pureColor="name === 'border' ? value.slice(-7) : value"
          :format="'hex6'"
          :isWidget="true"
          :disableAlpha="true"
          @pureColorChange="(hex) => { onChangeColumn(hex, name); }"
        />
        <a-select
          v-if="options && options.length"
          style="width: 180px"
          :value="{ label: value, text: value, value }"
          :options="getOptions(options)"
          @change="((e) => {
            onChangeColumn(e, name);
          })"
        />
        <a-switch
          v-if="isCheckbox"
          :checked="value"
          checked-children="Yes"
          un-checked-children="No"
          @click="() => { onChangeColumn(!value, name); }"
        />
      </div>
      <div :class="b('modal-buttons-wrap')" >
        <a-button
          type="primary"
          html-type="button"
          @click="saveStyle()"
        >
          Save
        </a-button>
        <a-button
          html-type="button"
          @click="close()"
        >
          Cancel
        </a-button>
      </div>
    </div>
  </modal-wrapper>
</template>;

<style src="./contentEditorStyle.scss" scoped lang="scss"></style>
